import React, { Fragment, FunctionComponent, useState } from "react";
import styles from "./Card.module.scss";
import BrandItemProps from "./CardProps.interface";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Anchor from "components/Anchor/Anchor";
import IconViewer from "components/IconViewer/IconViewer";

const Card: FunctionComponent<BrandItemProps> = (props): JSX.Element => {
    const imageAspectRatio = getImageAspectRatio(undefined, props.content.image?.umbracoWidth, props.content.image?.umbracoHeight);
    const imageUrl = props.content.image?.umbracoFile.src;

    return (
        <Fragment>
            <Anchor to={props.content?.mediaLink?._url}>
                <div className={styles.item} tabIndex={0}>

                    <div className={styles.inner}>
                        {/* Media */}
                        <div className={styles.image_wrapper}>
                            {props.content.image ? (
                                <ImageViewer className={styles.image} extensionType="png" src={imageUrl} alt={props.content.title ? props.content.title : "Brand Logo"} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} {...imageAspectRatio} />
                            ) : null}
                        </div>

                        {props.content.mediaLink ? (
                            <div className={styles.icon_wrapper}>
                                <IconViewer className={styles.icon} name="arrow-bottom-right" />
                            </div>
                        ) : null}

                    </div>
                    {props.content.title ? (
                        <h3 className={styles.title}>{props.content.title}</h3>
                    ) : null}
                </div>
            </Anchor>
        </Fragment>
    );
};

export default Card;